import type { ReactNode } from 'react'

import { Flex, Heading, Paragraph, Switch } from '@buffer-mono/popcorn'

import { RefreshChannelPopover } from './RefreshChannelPopover'
import styles from './LinkedInVerifiedSkills.module.css'
import commonStyles from '../../GeneralSettings.module.css'

type HeaderProps = {
  title: string
  description: ReactNode
  isDisabledState?: boolean
  isSwitchOn: boolean
  isSwitchDisabled: boolean
  isRefreshPopoverOpen: boolean
  shouldShowRefreshPopover: boolean
  onRefreshChannel: () => void
  onRefreshPopoverOpenChange: (isOpen: boolean) => void
  onSwitchChange: (checked: boolean) => void
}

const Header = ({
  title,
  description,
  isDisabledState = false,
  isSwitchOn,
  isSwitchDisabled,
  isRefreshPopoverOpen,
  shouldShowRefreshPopover,
  onRefreshChannel,
  onRefreshPopoverOpenChange,
  onSwitchChange,
}: HeaderProps): React.JSX.Element => {
  const switchElement = (
    <Switch
      aria-label={title}
      checked={isSwitchOn}
      disabled={isSwitchDisabled}
      onCheckedChange={onSwitchChange}
    />
  )

  return (
    <Flex direction="column" fullWidth gap="xl" className={commonStyles.row}>
      <Flex direction="column" gap="xs">
        <Heading
          size="sm"
          as="h3"
          className={isDisabledState ? styles.disabledHeading : undefined}
        >
          {title}
        </Heading>
        <Paragraph className={commonStyles.settingsParagraph}>
          {description}
        </Paragraph>
      </Flex>
      <Flex className={commonStyles.actionsWrapper}>
        <RefreshChannelPopover
          isEnabled={shouldShowRefreshPopover}
          isOpen={isRefreshPopoverOpen}
          onOpenChange={onRefreshPopoverOpenChange}
          onRefreshChannel={onRefreshChannel}
        >
          {switchElement}
        </RefreshChannelPopover>
      </Flex>
    </Flex>
  )
}

export { Header }
